import React, { Component } from "react";
import { connect } from "react-redux";
import { Alert, Avatar, Button, Dropdown, Menu, message, Modal, Spin, Tag } from "antd";
import { ImportOutlined } from '@ant-design/icons';

import QueueAnim from "rc-queue-anim";
import enquire from "enquire.js";

import { DESKTOP_DOWN } from "../../config/mediaQueries";

import { generalActions } from "./../../redux/actions";

import { employeesService } from "./../../redux/services";

import { equipmentsService } from "./../../redux/services";


import { IMask } from 'react-imask';

import {
	UIPageListing,
} from "./../../components";

import ModalCreate from "./create";
import ModalShow from "./show";
import ModalFilters from "./filters";
import ModalEdit from "./edit";
import ModalImports from "./imports";

const config = {
	title: "Funcionários",
	permissionPrefix: "funcionarios",
	list: "funcionarios",
	searchPlaceholder: "Buscar por nome ou CPF",
	orders: [
		{
			label: "Mais recentes",
			field: "id",
			sort: "desc",
			default: true,
		},
		{
			label: "Mais antigos",
			field: "id",
			sort: "asc",
		},
		{
			label: "Nome A|Z",
			field: "nome",
			sort: "asc",
		},
		{
			label: "Nome Z|A",
			field: "nome",
			sort: "desc",
		},
	],
};

class Index extends Component {
	constructor(props) {
		super(props);

		const defaultOrder = config.orders.find(o => o.default);

		this.state = {
			isLoading: false,
			listType: "list",
			data: [],
			pagination: {
				current: 1,
				pageSize: 20,
				total: 0,
			},
			orderByLabel: defaultOrder.label,
			orderByField: defaultOrder.field,
			orderBySort: defaultOrder.sort,
			search: "",
			// Actions
			createModalVisible: false,
			editModalVisible: false,
			showModalVisible: false,
			importsModalVisible: false,
			filtersModalVisible: false,
			activeLoadings: [],
			isImporting: false,
			passwordModalVisible: false,
			// Images
			imagePreviewVisible: false,
			imagePreviewImage: "",
			// Media queries
			desktopDown: false,
			// Filters
			filters: {
				is_active: 1,
				pis_pasep: null,
				cidade_id: null,
				numero_folha: null,
				numero_identificador: null,
				departamento_id: null,
				empresa_id: null,
			},
			devicesSendingEmployee: [],
			checkSendEmployeeInterval: null,
		};
	}

	static getDerivedStateFromProps(props, state) {
		if (props.listType && state.listType !== props.listType) {
			return {
				listType: props.listType
			};
		}

		return null;
	}

	componentDidMount() {
		// Fecth all
		this.fetchGetAll(true);

		// Listen Media Querie sideBar
		enquire.register(DESKTOP_DOWN, {
			match: () => {
				this.setState({
					desktopDown: true,
				})
			},
			unmatch: () => {
				this.setState({
					desktopDown: false,
				})
			}
		});

		this.initPoolingCheckSendEmployees();
	};

	componentWillUnmount() {
		// Unlisten Media Querie sideBar
		enquire.unregister(DESKTOP_DOWN);
		clearInterval(this.state.checkSendEmployeeInterval);
	};

	// Recebe comandos do ChatPrompt via CustomEvent
	menuItem = (item) => (
		<Menu className="actions-dropdown-menu">
			{this.props.permissions.includes(config.permissionPrefix + ".show") && <Menu.Item key="show">
				<a onClick={() => this.showOpen(item)}>
					<i className="fal fa-file" />Visualizar
				</a>
			</Menu.Item>}
			{this.props.permissions.includes(config.permissionPrefix + ".edit") && <Menu.Item key="edit">
				<a onClick={() => this.editOpen(item)}>
					<i className="fal fa-pen" />Editar
				</a>
			</Menu.Item>}
			{/* {this.props.permissions.includes(config.permissionPrefix + ".edit") && <Menu.Item key="activate/deactivate" className="divider">
				<a onClick={() => this.activateDeactivate(item, !item.is_active)}>
					{item.is_active ? <i className="fal fa-eye-slash" /> : <i className="fal fa-eye" />}{item.is_active ? "Desativar" : "Ativar"}
				</a>
			</Menu.Item>} */}
			{this.props.permissions.includes(config.permissionPrefix + ".delete") && <Menu.Item key="delete" className="divider btn-delete">
				<a onClick={() => this.deleteConfirm(item)}>
					<i className="fal fa-trash" />Excluir
				</a>
			</Menu.Item>}
		</Menu>
	);

	columns = () => {
		const listTypeCard = this.state.listType === "card";
		return [
			{
				className: "no-padding-horizontal no-ellipsis text-center",
				width: 70,
				render: (item) => {
					if(!item.avatar) {
						return <div style={listTypeCard ? {paddingTop: 30, paddingBottom: 15} : {}}>
							<i className="fad fa-user-circle avatar-placeholder" style={{fontSize: this.state.desktopDown || listTypeCard ? 100 : 60, color: "#b3b3b3" }} />
						</div>
					}

					return (
						<div style={listTypeCard ? {paddingTop: 30, paddingBottom: 15} : {}}>
							<a onClick={() => this.onImagePreview(item.avatar)}>
								<Avatar 
									size={this.state.desktopDown || listTypeCard ? 100 : 60} 
									src={item.avatar}
								/>
							</a>
						</div>
					)
				}
			},
			{
				title: "Nome",
				// width: 150,
				render: (item) => listTypeCard ? <h3>{item?.nome}</h3> : item?.nome,
			},
			{
				title: "CPF",
				// width: 150,
				render: (item) => listTypeCard ? <h3>{item.cpf}</h3> : item.cpf,
			},
			{
				title: "Empresa",
				// width: 150,
				render: (item) => listTypeCard ? <h3>{(item.contrato && item.contrato[0]?.empresa?.nome) ?? "-"}</h3> : (item.contrato && item.contrato[0]?.empresa?.nome) ?? "-",
			},
			{
				title: "Departamento",
				// width: 150,
				render: (item) => listTypeCard ? <h3>{(item.contrato && item.contrato[0]?.departamento?.nome) ?? "-"}</h3> : (item.contrato && item.contrato[0]?.departamento?.nome) ?? "-",
			},
			{
				title: "Nº da folha",
				width: 110,
				render: (item) => listTypeCard ? <h3>{item.numero_folha}</h3> : item.numero_folha,
			},
			{
				title: "Identificador",
				width: 110,
				render: (item) => listTypeCard ? <h3>{item.numero_identificador}</h3> : item.numero_identificador,
			},
			{
				title: "PIS/PASEP",
				width: 140,
				render: (item) => {
					const pisPasep = item.pis_pasep ? String(item.pis_pasep) : '000.00000.00-0';
					const maskedPisPasep = IMask.pipe(pisPasep, { mask: '000.00000.00-0' });
	
					return listTypeCard ? <h3>{maskedPisPasep}</h3> : maskedPisPasep;
				},
			},		
			{
				title: "Status",
				className: "active no-ellipsis",
				width: 90,
				render: (item) => this.state.activeLoadings.indexOf(item.uuid) !== -1 ? <Spin indicator={<i className="fad fa-spinner-third fa-spin" />} /> : <Tag color={item.ativo == 1 ? "#0acf97" : "#fa5c7c"}>{item.ativo == 1 ? "Ativo" : "Inativo"}</Tag>
			},
			{
				title: "Ações",
				className: "actions no-ellipsis",
				visible: this.props.permissions.includes(config.permissionPrefix + ".show") || this.props.permissions.includes(config.permissionPrefix + ".edit") || this.props.permissions.includes(config.permissionPrefix + ".delete"),
				render: (item) => (
					<Dropdown overlay={this.menuItem(item)} className="actions-dropdown" placement="bottomRight" trigger={["click"]}>
						<Button icon={<i className="fal fa-ellipsis-v" />} />
					</Dropdown>
				),
			},
		];
	};

	checkDevicesSendEmployees = () => {
		equipmentsService.getSendingEmployees()
			.then((response) => {
				const { devicesSendingEmployee } = this.state;
				const wasSendingEmployees = devicesSendingEmployee.length;

				this.setState({
					devicesSendingEmployee: response.data,
				});

				if (!response.data.length) {
					clearInterval(this.state.checkSendEmployeeInterval);

					if (wasSendingEmployees) {
						message.success('Atualização de funcionários concluída!');
					}

					this.setState({
						checkSendEmployeeInterval: null,
						devicesSendingEmployee: [],
					});
				}
			});
	}

	initPoolingCheckSendEmployees = () => {
		const interval = setInterval(() => {
			this.checkDevicesSendEmployees();
		}, 10000);

		this.setState({
			checkSendEmployeeInterval: interval 
		});
	}

	fetchGetAll = (init = false, exportItems = false) => {
		const { pagination, orderByField, orderBySort, search, filters } = this.state;
		if (exportItems) {
			this.setState({
				isImporting: true,
			});
		}
		else {
			this.setState({
				isLoading: true,
			});
		}

		const data = {
			orderBy: `${orderByField}:${orderBySort}`,
			search: search,
		};

		if (exportItems) {
			data.exportItems = true;
		}
		else {
			data.page = init ? 1 : pagination.current;
			data.limit = pagination.pageSize;
		}

		if (filters.cidade_id !== null) {
			data.cidade_id = filters.cidade_id;
		}

		if (filters.is_active !== null) {
			data.is_active = filters.is_active;
		}

		if (filters.departamento_id !== null) {
			data.departamento_id = filters.departamento_id;
		}

		if (filters.empresa_id !== null) {
			data.empresa_id = filters.empresa_id;
		}

		if (filters.pis_pasep !== null) {
			data.pis_pasep = filters.pis_pasep;
		}

		if (filters.numero_folha !== null) {
			data.numero_folha = filters.numero_folha;
		}

		if (filters.numero_identificador !== null) {
			data.numero_identificador = filters.numero_identificador;
		}

		if (filters.created_at) {
			data.created_at = [
				filters.created_at[0].clone().startOf("day").format("YYYY-MM-DDTHH:mm:ssZ"),
				filters.created_at[1].clone().endOf("day").format("YYYY-MM-DDTHH:mm:ssZ")
			];
		}

		employeesService.getAll(data)
			.then((response) => {
				if (exportItems) {
					this.setState({
						isImporting: false,
					});

					window.open(response.data.file_url, "_blank");
				}
				else {
					this.setState(state => ({
						isLoading: false,
						data: response.data.data,
						pagination: {
							...state.pagination,
							current: response.data.meta.current_page,
							total: response.data.meta.total,
						},
					}));
				}
			})
			.catch((data) => {
				Modal.error({
					title: "Ocorreu um erro!",
					content: String(data),
				});
			});
	};

	onListTypeChange = (type) => {
		this.props.onChangeListType(type);
	};

	onPaginationChange = (page, pageSize) => {
		this.setState(state => ({
			pagination: {
				...state.pagination,
				current: page,
				pageSize,
			},
		}), () => {
			this.fetchGetAll();
		});
	};

	onOrderChange = (value) => {
		const defaultOrder = config.orders.find(o => `${o.field}:${o.sort}` === value);

		if (!defaultOrder) return null;

		this.setState(state => ({
			orderByLabel: defaultOrder.label,
			orderByField: defaultOrder.field,
			orderBySort: defaultOrder.sort,
		}), () => {
			this.fetchGetAll(true);
		});
	};

	onSearch = (value) => {
		this.setState({
			search: value,
		}, () => {
			this.fetchGetAll(true);
		});
	};

	onSearchChange = (e) => {
		// If it does not have type then it's cleaning
		if (!e.hasOwnProperty("type")) {
			const { search } = this.state;

			this.setState({
				search: e.target.value,
			}, () => {
				if (search) {
					this.fetchGetAll(true);
				}
			});
		}
	};

	/**
	 * Show
	 *
	 * @param uuid
	 */
	showOpen = ({ uuid }, general_key) => {
		this.setState({ showModalVisible: true });

		// On open screen
		this.showScreen.onOpen(uuid, general_key);
	};

	showOnClose = () => {
		this.setState({ showModalVisible: false });
	};

	/**
	 * Delete
	 *
	 * @param uuid
	 */
	deleteConfirm = ({ uuid }) => {
		Modal.confirm({
			title: "Confirmar exclusão!",
			content: "Tem certeza de que deseja excluir este registro?",
			okText: "Excluir",
			autoFocusButton: null,
			onOk: () => {
				return this.deleteConfirmed(uuid);
			}
		});
	};

	deleteConfirmed = (uuid) => {
		return employeesService.destroy({ uuid })
			.then((response) => {
				// Fecth all
				this.fetchGetAll();
			})
			.catch((data) => {
				Modal.error({
					title: "Ocorreu um erro!",
					content: String(data),
				});
			});
	};

	/**
	 * Create
	 */
	createOpen = () => {
		this.setState({ createModalVisible: true });

		// On open screen
		this.createScreen.onOpen();
	};

	createOnClose = () => {
		this.setState({ createModalVisible: false });
	};

	createOnComplete = () => {
		this.setState({ createModalVisible: false });
		// Fecth all
		this.fetchGetAll(true)

		setTimeout(() => {
			this.showOpen(this.state.data[0]);
		}, 1000)

		this.initPoolingCheckSendEmployees();
	};

	/**
	 * Edit
	 *
	 * @param uuid
	 */
	editOpen = ({ uuid }) => {
		this.setState({ editModalVisible: true });

		// On open screen
		this.editScreen.onOpen(uuid);
	};

	editOnClose = () => {
		this.setState({ editModalVisible: false });
	};

	editOnComplete = () => {
		this.setState({ editModalVisible: false });

		// Fecth all
		this.fetchGetAll();

		this.initPoolingCheckSendEmployees();
	};

	/**
	 * Password
	 */
	passwordOpen = (item) => {
		this.setState({ passwordModalVisible: true });

		// On open screen
		this.passwordScreen.onOpen(item);
	};

	passwordOnClose = () => {
		this.setState({ passwordModalVisible: false });
	};

	passwordOnComplete = () => {
		this.setState({ passwordModalVisible: false });

		Modal.success({
			title: "E-mail enviado!",
			content: "Foi enviado para o usuário sua nova senha.",
		});
	};

	/**
	 * Filter
	 */
	filtersOpen = () => {
		this.setState({ filtersModalVisible: true });

		// On open screen
		this.filtersScreen.onOpen({ ...this.state.filters });
	};

	filtersOnClose = () => {
		this.setState({ filtersModalVisible: false });
	};

	filtersOnComplete = (filters) => {
		this.setState({ filtersModalVisible: false });
		this.setState({
			filters: filters,
		}, () => {
			// Fecth all
			this.fetchGetAll(true);
		});
	};

	/**
	 * Active/Desactive
	 *
	 * @param {number} uuid
	 * @param {boolean} activate
	 */
	activateDeactivate = ({ uuid }, activate) => {
		const { activeLoadings } = this.state;

		if (activeLoadings.indexOf(uuid) === -1) {
			activeLoadings.push(uuid);
		}

		this.setState({
			activeLoadings: activeLoadings,
		});

		employeesService.edit({ uuid, is_active: activate })
			.then((response) => {
				const newData = [...this.state.data];
				const index = newData.findIndex(item => uuid === item.uuid);

				if (index !== -1) {
					const item = newData[index];

					newData.splice(index, 1, {
						...item,
						status: response.data.data.status,
					});

					this.setState({
						data: newData,
					});
				}
			})
			.catch((data) => {
				Modal.error({
					title: "Ocorreu um erro!",
					content: String(data),
				});
			}).finally(() => {
				const { activeLoadings } = this.state;
				const index = activeLoadings.indexOf(uuid);

				if (index !== -1) {
					activeLoadings.splice(index, 1);

					this.setState({
						activeLoadings: activeLoadings,
					});
				}
			});
	};

	/**
	 * Image preview
	 */
	onImagePreviewClose = () => this.setState({ imagePreviewVisible: false });

	onImagePreview = (url) => {
		this.setState({
			imagePreviewImage: url,
			imagePreviewVisible: true,
		});
	};

	handleOpenModalImports = () => {
		this.setState(prevState => ({ importsModalVisible: !prevState.importsModalVisible }));
	};
	
	importsOnClose = () => {
		this.setState({ importsModalVisible: false });
	};

	importsOnComplete = () => {
		this.setState({ isImporting: true });
		setTimeout(() => {
			this.setState({ isImporting: false });
			this.setState({ importsModalVisible: false });
		}, 2000);
		
		// Fecth all
		this.fetchGetAll(true)
	};

	render() {
		const isSmallScreen = window.innerWidth < 1190;
		const { devicesSendingEmployee } = this.state;

		const devicesPreparingEmployees = devicesSendingEmployee.filter((item) => item.status_equipamento === "connected");
    	const devicesUpdatingEmployees = devicesSendingEmployee.filter((item) => item.status_equipamento === "updating_employees");

		return (
			<QueueAnim className="site-content-inner">
				{devicesPreparingEmployees.length && (
					<Alert
						message={`Preparando atualização de funcionarios no(s) equipamento(s) ${devicesPreparingEmployees
						.map(
						(item, index) =>
						`${item.descricao}${
							index === devicesPreparingEmployees.length - 1 ? "" : ", "
						}`
						)}`}
						type="info"
						style={{ marginBottom: 15 }}
					/>
				)}
				{devicesUpdatingEmployees.length && (
					<Alert
						message={`Atualizando funcionarios no(s) equipamento(s) ${devicesUpdatingEmployees
						.map(
						(item, index) =>
						`${item.descricao}${
							index === devicesUpdatingEmployees.length - 1 ? "" : ", "
						}`
						)}`}
						type="info"
						style={{ marginBottom: 15 }}
					/>
				)}
				<div className="page-content fixed-header" key="1">
					<h1 className="page-title">{config.title}</h1>
					<UIPageListing
						onSearch={this.onSearch}
						onSearchChange={this.onSearchChange}
						onPaginationChange={this.onPaginationChange}
						onOrderChange={this.onOrderChange}
						onListTypeChange={this.onListTypeChange}
						onFiltersClick={this.filtersOpen}
						isLoading={this.state.isLoading}
						listType={this.state.listType}
						orderByField={this.state.orderByField}
						orderBySort={this.state.orderBySort}
						orders={config.orders}
						search={this.state.search}
						searchPlaceholder={config.searchPlaceholder}
						data={this.state.data}
						pagination={this.state.pagination}
						columns={this.columns()}
						showFilters={true}
						buttons={[
							{
								visible: this.props.permissions.includes(config.permissionPrefix + ".create"),
								onClick: this.createOpen,
								title: "Incluir",
								icon: <i className="far fa-plus" />,
							},
							{
								visible: this.props.permissions.includes(config.permissionPrefix + ".create"),
								onClick: () => this.handleOpenModalImports(),
								title: this.state.isImporting ? "Importando" : "Importar",
								icon: isSmallScreen ? <i className="fa fa-upload" /> :  <ImportOutlined />,
								loading: this.state.isImporting,
							},
						]}
					/>
				</div>
				<ModalCreate
					ref={el => this.createScreen = el}
					visible={this.state.createModalVisible}
					onComplete={this.createOnComplete}
					onClose={this.createOnClose}
				/>
				<ModalEdit
					ref={el => this.editScreen = el}
					visible={this.state.editModalVisible}
					onComplete={this.editOnComplete}
					onClose={this.editOnClose}
				/>
				<ModalShow
					ref={el => this.showScreen = el}
					visible={this.state.showModalVisible}
					onClose={this.showOnClose}
				/>
				<ModalFilters
					ref={el => this.filtersScreen = el}
					visible={this.state.filtersModalVisible}
					onComplete={this.filtersOnComplete}
					onClose={this.filtersOnClose}
				/>
				<ModalImports
					visible={this.state.importsModalVisible}
					onComplete={this.importsOnComplete}
					onClose={this.importsOnClose}
					loading={this.state.isImporting}
				/>
				<Modal wrapClassName="modal-image" visible={this.state.imagePreviewVisible} centered footer={null} destroyOnClose={true} onCancel={this.onImagePreviewClose}>
					<img src={this.state.imagePreviewImage} />
				</Modal>
			</QueueAnim>
		)
	}
}

const mapStateToProps = (state, ownProps) => {
	return {
		permissions: state.auth.userData.permissions,
		listType: state.general.listType[config.list],
	};
};

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		onChangeListType: (type) => {
			dispatch(generalActions.changeListType(config.list, type));
		}
	}
};

export default connect(mapStateToProps, mapDispatchToProps)(Index);
